export default __webpack_public_path__ + "static/media/img-0014.8d6d4f28.png";